import {Component, OnInit, ViewChild, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { FireBplanService } from 'src/app/services/fire-bplan-services/fire-bplan.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { HttpClient } from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import { ModalsService } from '../../../modals/modals.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
//import {MatStepperModule} from '@angular/material/stepper';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import * as html2pdf from 'html2pdf.js';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { asBlob } from 'html-docx-js-typescript';
// if you want to save the docx file, you need import 'file-saver'
import { saveAs } from 'file-saver';
import { HtmldocxService } from 'src/app/services/htmldocx/htmldocx.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Bplan } from 'src/app/models/bplan';
import { threadId } from 'worker_threads';


interface ImplementationStatus {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-business-plan',
  templateUrl: './business-plan.component.html',
  styleUrls: ['./business-plan.component.scss'],
})

export class BusinessPlanComponent implements OnInit, AfterViewInit, OnDestroy {

  private unsubscribe = new Subject();
  isLinear = false;
  panelOpenState = false;
  //implement Read More
  isReadMore = true;

  states = [
    { name: 'Pennsylvania', abbreviation: 'PA' },
    { name: 'North Carolina', abbreviation: 'NC' },
    { name: 'Ohio', abbreviation: 'OH' },
  ];

  bplanBusiTypeDropDown = [
    {name: 'business'},
    {name: 'firm'},
    {name: 'agency'},
    {name: 'platform'},
    {name: 'store'},
    {name: 'organization'},
  ]

  bplanBusiOfferTypeDropDown = [
    {name: 'product'},
    {name: 'service'},
    {name: 'product and service'},
  ]

  bplanBusiOperationsTypeDropDown = [
    {name: 'an office'},
    {name: 'a home office'},
    {name: 'a retail location'},
    {name: 'a mobile location'},
  ]

  
  bPlanIndustryTypeDropDown = [
    {name: 'Advertising' },
    {name: 'Aerospace/Defense'        },
    {name: 'Air Transport'        },
    {name: 'Apparel'        },
    {name: 'Auto & Truck'        },
    {name: 'Auto Parts'        },
    {name: 'Bank (Money Center)'        },
    {name: 'Banks (Regional)'        },
    {name: 'Beverage (Alcoholic)'        },
    {name: 'Beverage (Soft)'        },
    {name: 'Broadcasting'        },
    {name: 'Brokerage & Investment Banking'        },
    {name: 'Building Materials'        },
    {name: 'Business & Consumer Services'        },
    {name: 'Cable TV'        },
    {name: 'Chemical (Basic)'        },
    {name: 'Chemical (Diversified)'        },
    {name: 'Chemical (Specialty)'        },
    {name: 'Coal & Related Energy'        },
    {name: 'Computer Services'        },
    {name: 'Computers/Peripherals'        },
    {name: 'Construction Supplies'        },
    {name: 'Diversified'        },
    {name: 'Drugs (Biotechnology)'        },
    {name: 'Drugs (Pharmaceutical)'        },
    {name: 'Education'        },
    {name: 'Electrical Equipment'        },
    {name: 'Electronics (Consumer & Office)'        },
    {name: 'Electronics (General)'        },
    {name: 'Engineering/Construction'        },
    {name: 'Entertainment'        },
    {name: 'Environmental & Waste Services'        },
    {name: 'Farming/Agriculture'        },
    {name: 'Financial Svcs. (Non-bank & Insurance)'        },
    {name: 'Food Processing'    },
    {name: 'Food Wholesalers'    },
    {name: 'Furn/Home Furnishings'    },
    {name: 'Green & Renewable Energy'    },
    {name: 'Healthcare Products'    },
    {name: 'Healthcare Support Services'    },
    {name: 'Heathcare Information and Technology'    },
    {name: 'Homebuilding'    },
    {name: 'Hospitals/Healthcare Facilities'    },
    {name: 'Hotel/Gaming'    },
    {name: 'Household Products'    },
    {name: 'Information Services'    },
    {name: 'Insurance (General)'    },
    {name: 'Insurance (Life)'    },
    {name: 'Insurance (Prop/Cas.)'    },
    {name: 'Investments & Asset Management'    },
    {name: 'Machinery'    },
    {name: 'Metals & Mining'    },
    {name: 'Office Equipment & Services'    },
    {name: 'Oil/Gas (Integrated)'    },
    {name: 'Oil/Gas (Production and Exploration)'    },
    {name: 'Oil/Gas Distribution'    },
    {name: 'Oilfield Svcs/Equip.'    },
    {name: 'Packaging & Container'    },
    {name: 'Paper/Forest Products'    },
    {name: 'Power'    },
    {name: 'Precious Metals'    },
    {name: 'Publishing & Newspapers'    },
    {name: 'R.E.I.T.'    },
    {name: 'Real Estate (Development)'    },
    {name: 'Real Estate (General/Diversified)'    },
    {name: 'Real Estate (Operations & Services)'    },
    {name: 'Recreation'    },
    {name: 'Reinsurance'    },
    {name: 'Restaurant & Dining'
    },
    {name: 'Retail (Automotive)'
    },
    {name: 'Retail (Building Supply)'
    },
    {name: 'Retail (Distributors)'
    },
    {name: 'Retail (General)'
    },
    {name: 'Retail (Grocery and Food)'
    },
    {name: 'Retail (Online)'
    },
    {name: 'Retail (Special Lines)'
    },
    {name: 'Rubber& Tires'
    },
    {name: 'Semiconductor'
    },
    {name: 'Semiconductor Equip'
    },
    {name: 'Shipbuilding & Marine'
    },
    {name: 'Shoe'
    },
    {name: 'Software (Entertainment)'
    },
    {name: 'Software (Internet)'
    },
    {name: 'Software (System & Application)'
    },
    {name: 'Steel'
    },
    {name: 'Telecom (Wireless)'
    },
    {name: 'Telecom. Equipment'
    },
    {name: 'Telecom. Services'
    },
    {name: 'Tobacco'
    },
    {name: 'Transportation'
    },
    {name: 'Transportation (Railroads)'
    },
    {name: 'Trucking'
    },
    {name: 'Utility (General)'
    },
    {name: 'Utility (Water)'
    }
  ];

  bplanBusiRegStatusDropDown = [
    {name: 'intends to register'},
    {name: 'is registered'},
  ];

  bplanBusiRegTypeDropDown = [
    {name: 'a non-profit'},
    {name: 'an LLC'},
    {name: 'an LLP'},
    {name: 'a sole-proprietorship '},
  ]

  bplanOfferTypeDropDown = [
    'Product',
   'Service'
  ]

  bplanOfferPriceTypeDropDown = [
    'Hourly','Weekly','Monthly', 'Yearly','Flat Rate'
  ]

  bplanBusiOfferPriceDeterminantDropDown = [
    {name: 'vary based on supplier'},
    {name: 'are usually estimated on a project based cost'},
  ];
  
  bplanBusiMarketStrategyDropDown  = [
    {name: 'Social Media Marketing'},
    {name: 'Outreach'},
    {name: 'Partnerships'},
    {name: 'Advertising'},
    {name: 'Responding to Call for Proposals'},
    {name: 'Digital Ads'},
    {name: 'Content Marketing'},
    {name: 'Coupons and Discounts'},
    {name: 'Blogs'},
    {name: 'Direct Mail Marketing'},
    {name: 'Speaking Engagements'},
    {name: 'Attending Events'},
  ];
  
  bplanCustomerStatusDropDown = [
    {name: 'already has customers'},
    {name: 'is a start-up'},
  ];

  bplanMilestoneTimelineDropDown= [
    {name: 'year'},
    {name: 'quarter'},
    {name: 'six months'},
    {name: 'few months'},
    {name: 'month'},

  ];



  constructor(
    public fireBplan: FireBplanService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private guard: AuthGuard,
    private http: HttpClient,
    public matDialog: MatDialog,
    public modal: ModalsService,
    public tooltip: MatTooltipModule, 
    public html2docx: HtmldocxService,
    private _ngZone: NgZone,
    private dbstore: AngularFirestore,
    private _snackbar:MatSnackBar
    

  ) { }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  public show: boolean = true;
  public hide: boolean = false;
  public firstFormGroup: FormGroup;
  public ExecutiveSummaryFormGroup: FormGroup;
  public CompanyDescriptionFormGroup: FormGroup;
  public CompanySummaryFormGroup: FormGroup;
  public BusinessOfferingFormGroup: FormGroup;
  public MarketingFormGroup: FormGroup;
  public IndustryFormGroup: FormGroup;
  public StrategyFormGroup: FormGroup;
  public ManagementFormGroup: FormGroup;
   bplanTeamNames: FormArray;
   bPlanLongTermGoals: FormArray;
   bPlanShortTermGoals: FormArray;
   bPlanOfferArray: FormArray;
  public bPlandata: AngularFirestoreDocument<any>;
  public  dataBplan!: any;
  busiPlanID: any
  bPlanID: any;

  

 // Business section code
   isEditable: boolean = false;
   text: any;
   myData: any;
   postData: any = window.localStorage.getItem("save");

   data!: any;
  

  //Demographics
 todaysDate = new Date().toLocaleDateString();
 
 //bplan Variables
 bplanBusiName: string;
  offerDifferentiationNameArray: any[] = [];
  B2BValueCopy!: number;
  assessmentPayload: any;

  
 showTxt() {
    this.isReadMore = !this.isReadMore;
  }

  ngOnInit(): void {
    this.busiPlanForm();
    this.checkStorage("businessPlan");
  }

  ngOnDestroy(): void {
      this.unsubscribe.next();
      this.unsubscribe.complete();
  }
  
  ngAfterViewInit() {
    this.text = document.getElementById('myText');
   // this.loadData();  
  }

  async saveToFireB(){
    this.saveBPlanToSession(this.firstFormGroup.value);
    await this.dbstore.collection('user-bPlan').doc(this.guard.uid).get().toPromise()
    .then((doc) => {
    if (doc.exists) {
      // console.log("here")
      this.fireBplan.updateSustainibleBplan(doc.id, this.dataBplan);
  } else {
      // doc.data() will be undefined in this case
      
      this.snackbar('No such User',3000)
  }
  }).catch((error) => {
    this.snackbar('Error. Please log in and try again',3000)
    
  });

   
  

  }

  update(){

    this.saveBPlanToSession(this.firstFormGroup.value);
    // this.readSustainibleBplan(this.busiPlanID);
  }

  checkStorage(item: string){
    if (sessionStorage.getItem(item) === null) {
      this.getBPlanID();
      
    }  
    else{
      var values= JSON.parse(sessionStorage.getItem(item))
      this.dataBplan=values;
      this.editTeamName();
      this.editLongTermGoal();
      this.editOffer();
      this.editShortTermGoal();
    }
  }
 
  snackbar(message: string, duration: number){
    this._snackbar.open(message, '',{
      duration:duration,
    })
  }
  async getBPlanID (){
    await this.dbstore.collection('user-bPlan').doc(this.guard.uid).get().toPromise()
            .then((doc) => {
            if (doc.exists) {
               this.savePlanIDToSession(doc.id)
               this.readSustainibleBplan(doc.id);
          } else {
            this.snackbar('No such document',3000)
          }
          }).catch((error) => {
            this.snackbar('Error getting document',3000)
          });
}

  readSustainibleBplan(id:string) {
           //define all variables of a single assessment
      this.bPlandata = this.fireBplan.sustainibleBPlanRef.doc(id);
      this.bPlandata.valueChanges()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next : (payload) => {
          // this.dataBplan = payload as BusinessPlanComponent;
           this.saveBPlanToSession( payload as BusinessPlanComponent); 

          }
      });
    }

    saveBPlanToSession(businessPlan){
    this.dataBplan = this.saveToSession('businessPlan', businessPlan)
    }
    
    savePlanIDToSession(userId){
      this.busiPlanID  = this.saveToSession('busiPlanID',userId)
    }

    saveToSession(itemName: string, data: any){
      try{
        sessionStorage.setItem(itemName, JSON.stringify(data));
      }
      catch(e){
        debugger
        console.log(e);
      }
      return JSON.parse(sessionStorage.getItem(itemName))
      
    }
  // tslint:disable-next-line:typedef
  busiPlanForm() {
    this.firstFormGroup  = this._formBuilder.group({
      bplanBusiName: [null, Validators.required],
      bplanBusiStreet: null,
      bplanBusiStreet2: null,
      bplanBusiCity: null,
      bplanBusiState: null,
      bplanBusiZipcode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(5),
        ]),
      ],
       bplanBusiType: null,
       bplanCustomerPersonaSummary: null,
       bplanOfferSummary: null,
       bplanBusiOfferType: null,
       bplanCustomerLocation: null,
       bplanBusiOperationsType: null,
       bPlanCustomerCharacterstic: null,
       bplanCustomerAppeal: null,
       bplanTeamNames: this._formBuilder.array([]),
       bplanLongTermGoals: this._formBuilder.array([]),
       bplanTeamSummary: null,
       bPlanMarketingSummary: null,
       bPlanMission: null,
       bPlanMissionExpanded: null,
       bplanKeysToSuccess: null,
       bPlanIndustryType: null,
       bplanBusinessAge: null,
       bplanBusiRegStatus: null,
       bplanBusiRegType: null,
       bPlanOfferArray: this._formBuilder.array([]),
       bplanBusiOfferPriceDeterminant: null,
       bPlanOfferingExpansion: null,
       bPlanMarketDescription: null,
       bPlanMarketDemographicNotes: null,
       bPlanMarketResearchNotes: null,
       bPlanMarketTargetSummary: null,
       bPlanIndustryAnalysis: null,
       bPlanCompetitionDescription: null,
       bplanBusiMarketStrategy: null,
       bplanBusiMarketStrategyDescription: null,
       bPlanBusiSalesStrategyDescription: null,
       bplanCustomerStatus: null,
       bPlanBusiSalesForecastDescription: null,
       bplanMilestoneTimeline: null,
       bplanShortTermGoals: this._formBuilder.array([]),
       bplanDifferentiationList: null,
       bPlanDifferentiationExpansion: null,
       bplanPersonnelPlan: null,
       
    });
  }

  ResetForm() { //add void as in other one?
    this.firstFormGroup.reset();
    sessionStorage.clear();
  }

 

  setPlaceholders(){
    this.firstFormGroup.patchValue({bPlanCustomerCharacterstic:'The target customer is businesses who' })
    this.firstFormGroup.patchValue({bPlanMission: 'Our mission is to'});
    this.firstFormGroup.patchValue({bPlanMissionExpanded: 'We empower our customer by'});
    this.firstFormGroup.patchValue({bPlanMarketingSummary: '[businessName] will grow its customers by'})
    this.firstFormGroup.patchValue({bPlanBusiSalesStrategyDescription: 'Our sales strategy is to'})
    this.firstFormGroup.patchValue({bplanDifferentiationList: 'We pride ourselves on our'})
    this.firstFormGroup.patchValue({bPlanDifferentiationExpansion: 'We are differentiated in [xyz]. Unlike our competitors, we [xyz]'})
    
  }

  goBack() {
    this.location.back();
  }
//////////////Add Team Members/////////////////////\

  teamNames() : FormArray {
      return this.firstFormGroup.get("bplanTeamNames") as FormArray
  }

  newFormGroup(page): FormGroup {
    switch (page) {
      case "LongTermGoals":
        return this._formBuilder.group({
          bplanLongTermGoal: null,
          bPlanArrayNumber: this.LongTermGoalsCount,
        })
        break;
      case "ProductsOrServicesOffer":
        return this._formBuilder.group({
          bplanOfferName: null,
          bplanOfferType: null,
          bplanOfferPrice: null,
          bplanOfferPriceType: null,
          bplanOfferDescription: null,
        })
        break;
      case "ShortTermGoals":
        return this._formBuilder.group({
          bplanShortTermGoal: null,
        })
        break;
      case "TeamMembers":
        return this._formBuilder.group({
          bPlanTeamFirstName: null,
          bPlanTeamLastName: null,
          bPlanTeamMemberDescription: null,
        })
        break;
      default:
        debugger;
        this.snackbar("Form group not defined",3000)
        break;
    }
   
  }
  
  public teaminit = false
  editTeamName(){
    this.teaminit=false
    if(!this.teaminit){
      this.teamNames().clear()
        for (var val of this.dataBplan?.bplanTeamNames) {
          if(val.bPlanTeamFirstName != null && val.bPlanTeamLastName != null ){
            this.teamNames().push(
              this._formBuilder.group({
               bPlanTeamFirstName: val.bPlanTeamFirstName,
               bPlanTeamLastName: val.bPlanTeamLastName,
               bPlanTeamMemberDescription: val.bPlanTeamMemberDescription,
             }) as FormGroup)
          }
        }
    }
   

 
  }
  addTeamName(isUpdating) {
    this.teaminit = true
    if (this.teaminit) {
      if(!isUpdating){
            if (this.firstFormGroup.controls.bPlanTeamFirstName!=null || this.firstFormGroup.controls.bPlanTeamFirstName!=null){
                this.teamNames().push(this.newFormGroup("TeamMembers"));
            }
      }
      else if(isUpdating){
        this.teamNames().push(this.newFormGroup("TeamMembers"));
      }
    }
  }
  disregardTeamName(i: number){
    this.teaminit = false
    this.removeTeamName(i)
  }
  removeTeamName(i:number) {
    this.teamNames().removeAt(i);
  }

  ////////////////Add Long Term Goal/////////////////
  longTermGoals() : FormArray {
    return this.firstFormGroup.get("bplanLongTermGoals") as FormArray
  }

   LongTermGoalsCount = 0;


  public longTermInit=false

  addLongTermGoal(bool) {
  this.longTermInit=true
  if(this.longTermInit){
    if(bool){
      this.longTermGoals().push(this.newFormGroup("LongTermGoals"));
      this.LongTermGoalsCount++
    }
   else if(!bool){
     if(this.firstFormGroup.controls.bplanLongTermGoal!=null){
      this.longTermGoals().push(this.newFormGroup("LongTermGoals"));
      this.LongTermGoalsCount++
     }
   }
  } 
  }

  editLongTermGoal() {
    this.longTermInit=false
    if(!this.longTermInit){
      this.longTermGoals().clear()
        for (var val of this.dataBplan?.bplanLongTermGoals) {
          if(val.bplanLongTermGoal != null ){
              this.longTermGoals().push(
              this._formBuilder.group({
                bplanLongTermGoal: val.bplanLongTermGoal,
                bPlanArrayNumber: val.bPlanArrayNumber,
             
             }) as FormGroup)
          }

        }
    }
  
   }
 
  removeLongTermGoal(x: number) {
    this.longTermGoals().removeAt(x);
    this.LongTermGoalsCount= this.LongTermGoalsCount - 1;
  }


  retrieveLongTermGoal(index: number) {
    
          const longTermGoal = this.dataBplan?.find("bplanLongTermGoals.bplanLongTermGoal", "array-contains" , index)
          return (longTermGoal);
    }
     


  
goalsArray() {
  
  var x;
 x = this.dataBplan?.bplanLongTermGoals?.map((bplanLongTermGoal: any) => bplanLongTermGoal);
 return x;
};


  /////Add Products or Services//////
  public offerInit: boolean;
  getOfferArray() : FormArray {
    return this.firstFormGroup.get("bPlanOfferArray") as FormArray
  }

  
  addOffer(bool) {
    this.offerInit=true;
    if(this.offerInit){
      if(bool){
          this.getOfferArray().push(this.newFormGroup("ProductsOrServicesOffer"));
      }
      else if(!bool){
        if(this.firstFormGroup.controls.bplanOfferPriceType!=null)
        {
          this.getOfferArray().push(this.newFormGroup("ProductsOrServicesOffer"));
        }

      }
      
    }
   
  }

  editOffer(){
    // this.edit2(this.offerInit,this.getOfferArray(),this.dataBplan?.bPlanOfferArray,"ProductsOrServicesOffer",this._formBuilder)
    this.offerInit=false;
    if(!this.offerInit){
      this.getOfferArray().clear()
        for (var val of this.dataBplan?.bPlanOfferArray) {
          if(val.bplanOfferName != null && val.bplanOfferType!= null &&    val.bplanOfferPrice!= null && val.bplanOfferPriceType!= null && val.bplanOfferDescription!= null ){
            this.getOfferArray().push(
              this._formBuilder.group({
                bplanOfferName: val.bplanOfferName,
                bplanOfferType: val.bplanOfferType,
                bplanOfferPrice: val.bplanOfferPrice,
                bplanOfferPriceType: val.bplanOfferPriceType,
                bplanOfferDescription: val.bplanOfferDescription,
             }) as FormGroup)
          }
        }

    }
  }

  removeOffer(i:number) {
    this.getOfferArray().removeAt(i);
  }

   ///////Add Short Term Goal/////////////
   public shortTermGoalsInit: boolean;
   shortTermGoals() : FormArray {
    return this.firstFormGroup.get("bplanShortTermGoals") as FormArray
  }

  addShortTermGoal(bool) {
    this.shortTermGoalsInit=true;
    if (this.shortTermGoalsInit) {
      if (bool){
        this.shortTermGoals().push(this.newFormGroup("ShortTermGoals"));
      }
      else if(!bool){
        if(this.firstFormGroup.controls.bplanShortTermGoal != null){
          this.shortTermGoals().push(this.newFormGroup("ShortTermGoals"));
        }
      }
  
      
    }
  
  }
  editShortTermGoal() {
    this.shortTermGoalsInit=false;
    if (!this.shortTermGoalsInit){
        this.shortTermGoals().clear()
        for (var val of this.dataBplan?.bplanShortTermGoals) {
          if(val.bplanShortTermGoal != null ){
            this.shortTermGoals().push(
              this._formBuilder.group({
                bplanShortTermGoal: val.bplanShortTermGoal,
             }) as FormGroup)
          }
        }
    }
    
   }

  removeShortTermGoal(x: number) {
    this.shortTermGoals().removeAt(x);
  }

  //Retrieve Arrays
 retrieveTeamNames(property: string): string {
   
    const teamNamesArray = this.dataBplan?.bplanTeamNames?.find((bPlanTeamFirstName: any) => bPlanTeamFirstName?.hasOwnProperty(property) && bPlanTeamFirstName[property]);
    return (teamNamesArray && teamNamesArray[property]);
  }

  retrieveLongTermGoals(property: string): string {
    const longTermGoalsArray = this.dataBplan?.bplanLongTermGoals?.find((bplanLongTermGoal: any) => bplanLongTermGoal?.hasOwnProperty(property) && bplanLongTermGoal[property]);
      return (longTermGoalsArray && longTermGoalsArray[property]);
  }

  
  exportOnClick(type: string) {
    // string can be either "pdf" or "docx"
    const filename: string = "BusinessPlan";
    const content: Element = document.getElementById('element-to-export');
    let fileOptions= this.fetchOptions(filename);
    const html2PDFoptions = fileOptions[0];
    const html2DOCXoptions = fileOptions[1];

    switch (type) {
      case "pdf":
          html2pdf()
          .from(content)
          .set(html2PDFoptions)
          .save();
          break;
      case "docx":
        this.html2docx.convert(content.outerHTML,filename,content,html2DOCXoptions)
          break;
      default:
        this.snackbar('File type not defined',3000)
        break;
    }
  }

  fetchOptions(filename: string){
    return [ 
      {
        // html to pdf options
      filename: filename+'.pdf',
      image: {type: 'jpeg'},
      html2canvas: {} ,
      jsPDF: {orientation: 'portrait'}, 
      margin: 12, 
      pagebreak: {mode: 'avoid-all'},

	   },    
    {
      // html to docx options
      margin: {
        top: 100,
        left:15,
        right: 15,
      },
      orientation: 'portrait' as const,
    }];
  }



  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }

   // Turns contenteditable to true and hides the edit button after click
   toggleEdit() {
     this.isEditable = true;
   }
 
   // Doesn't save changes reveals edit button again and hides save and cancel buttons
   cancelEdit() {
     this.isEditable = false;
   }
   // Code from https://jsfiddle.net/zrd86n2v/4/
   // These functions are connected to the business section HTML at the end and connected to buttons
 
   // Supposed to load saved text, need to connect to database
   loadData() {
     // if no data
     if (this.postData == null || this.postData == '') {
         this.myData = this.text.innerHTML;
         // store default value
         window.localStorage.setItem("save", this.myData);
         // make it placeholder style
         this.text.classList.remove('changed');
     } else {
         // if there is a value post it
         this.text.innerHTML = this.postData;
         // make dark text
         this.text.classList.add('changed');
     }
   }
 
   // Saves changes and reveals edit button while hiding save and cancel buttons on click
   saveEdit() {
       this.isEditable = false;
       // store the current value
       this.myData = this.text.innerHTML;
       // local store the value
       window.localStorage.setItem("save", this.myData);
       this.text.classList.add('changed');
   }
   
   inputToForm(myDictionary){
  //  this.firstFormGroup.setValue(this.dataBplan)
    const myarrr=[]
      for (let key in myDictionary) {
        // let value = ;
        // Use `key` and `value`
        myarrr.push(myDictionary[key])
    }
    
   }
  

 
}
